import { render, staticRenderFns } from "./TriggerEditor.vue?vue&type=template&id=967353e6&scoped=true&"
import script from "./TriggerEditor.vue?vue&type=script&lang=js&"
export * from "./TriggerEditor.vue?vue&type=script&lang=js&"
import style0 from "./TriggerEditor.vue?vue&type=style&index=0&id=967353e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967353e6",
  null
  
)

export default component.exports